<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
            <v-divider/>
            <v-card-text>Are you sure you want to remove this discount ?</v-card-text>
            <v-card-text>{{ akcd_oms }}</v-card-text>
            <v-divider/>
            <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn class="warning mx-2" small @click="rmAkcd">Yes</v-btn>
                <v-btn color="success"      small @click="dialog = false">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                akcd_encrid: "",
                akcd_oms: ""
            }
        },
        methods: {
            openDialog(akcd_encrid, akcd_oms) {
                this.akcd_encrid = akcd_encrid;
                this.akcd_oms = akcd_oms;
                this.dialog = true;
            },
            rmAkcd() { 
                this.$axios.post("ares/json/ares/syst/ref/akcd/rmAkcdv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmAkcdv2"
                    },
                    rmAkcdv2: {
                        akcd_encrid: this.akcd_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else { 
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.rmAkcdv2.text,
                            color: res.data.rmAkcdv2.color
                        });
                        this.$emit("refreshList");
                        this.dialog = false;
                    }
                })
            },
        }
    }
</script>

